export function InvalidRoute(props: {path: string}) {
    window.location.href = window.location.href.substring(0, window.location.href.indexOf(props.path));
    return null;
}

export default InvalidRoute;